import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Add_State_Pay_In_Meta, Delete_State_Pay_In_Meta, Get_Available_State_Payment_Meta, Merchant_state_pay_in_meta, State_pay_in_meta, Update_State_Pay_In_Meta_Daily_Limit, Update_State_Pay_In_Meta_Level, Update_State_Pay_In_Meta_Max_Limit, Update_State_Pay_In_Meta_Method, Update_State_Pay_In_Meta_Min_Limit, Update_State_Pay_In_Meta_Per_Limit, Update_State_Pay_In_Meta_Status } from "../services/statePayInMetaServices";

const initialState = {
    statePayInMetaData: {},
    merchantStatePayInMetaData: {},
    availablePayment: {},
    isLoading: false,
};

export const GetStatePayInMeta = createAsyncThunk(
    "/getStatePayInMeta",
    async (payload) => {
        return await State_pay_in_meta(payload);
    }
);

export const GetMerchantStatePayInMeta = createAsyncThunk(
    "/getMerchantStatePayInMeta",
    async (payload) => {
        return await Merchant_state_pay_in_meta(payload);
    }
);

export const GetAvailableStatePaymentMeta = createAsyncThunk(
    "/getAvailableStatePaymentMeta",
    async (payload) => {
        return await Get_Available_State_Payment_Meta(payload);
    }
);

export const AddStatePayInMeta = createAsyncThunk(
    "/addStatePayInMeta",
    async (payload) => {
        return await Add_State_Pay_In_Meta(payload);
    }
);

export const UpdateStatePayInMetaMethod = createAsyncThunk(
    "/updateStatePayInMetaMethod",
    async (payload) => {
        return await Update_State_Pay_In_Meta_Method(payload);
    }
);

export const UpdateStatePayInMetaLevel = createAsyncThunk(
    "/updateStatePayInMetaLevel",
    async (payload) => {
        return await Update_State_Pay_In_Meta_Level(payload);
    }
);

export const UpdateStatePayInMetaStatus = createAsyncThunk(
    "/updateStatePayInMetaStatus",
    async (payload) => {
        return await Update_State_Pay_In_Meta_Status(payload);
    }
);

export const UpdateStatePayInMetaMinLimit = createAsyncThunk(
    "/updateStatePayInMetaMinLimit",
    async (payload) => {
        return await Update_State_Pay_In_Meta_Min_Limit(payload);
    }
);

export const UpdateStatePayInMetaMaxLimit = createAsyncThunk(
    "/updateStatePayInMetaMaxLimit",
    async (payload) => {
        return await Update_State_Pay_In_Meta_Max_Limit(payload);
    }
);

export const UpdateStatePayInMetaDailyLimit = createAsyncThunk(
    "/updateStatePayInMetaDailyLimit",
    async (payload) => {
        return await Update_State_Pay_In_Meta_Daily_Limit(payload);
    }
);

export const UpdateStatePayInMetaPerLimit = createAsyncThunk(
    "/updateStatePayInMetaPerLimit",
    async (payload) => {
        return await Update_State_Pay_In_Meta_Per_Limit(payload);
    }
);

export const DeleteStatePayInMeta = createAsyncThunk(
    "/deleteStatePayInMeta",
    async (payload) => {
        return await Delete_State_Pay_In_Meta(payload);
    }
);

const statePayInMetaSlice = createSlice({
    name: "statePayInMetaSlice",
    initialState,
    reducers: {
        clearStatePayInMeta: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(GetStatePayInMeta.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GetStatePayInMeta.fulfilled, (state, action) => {
            state.isLoading = false;
            state.statePayInMetaData = action.payload;
        });
        builder.addCase(GetStatePayInMeta.rejected, (state, action) => {
            state.isLoading = false;
        });

        builder.addCase(GetMerchantStatePayInMeta.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GetMerchantStatePayInMeta.fulfilled, (state, action) => {
            state.isLoading = false;
            state.merchantStatePayInMetaData = action.payload;
        });
        builder.addCase(GetMerchantStatePayInMeta.rejected, (state, action) => {
            state.isLoading = false;
        });

        builder.addCase(GetAvailableStatePaymentMeta.fulfilled, (state, action) => {
            state.availablePayment = action.payload;
        });
    },
});
export default statePayInMetaSlice.reducer;
export const { clearStatePayInMeta } = statePayInMetaSlice.actions;

export const selectStatePayInMetaState = (state) => {
    return state.statePayInMeta.statePayInMetaData;
};

export const selectMerchantStatePayInMetaState = (state) => {
    return state.statePayInMeta.merchantStatePayInMetaData;
};

export const selectAvailableStatePaymentMeta = (state) => {
    return state.statePayInMeta.availablePayment;
}

export const useStatePayInMeta = () => {
    const statePayInMetaData = useSelector(selectStatePayInMetaState);
    return useMemo(() => statePayInMetaData, [statePayInMetaData]);
};

export const useMerchantStatePayInMeta = () => {
    const merchantStatePayInMetaData = useSelector(selectMerchantStatePayInMetaState);
    return useMemo(() => merchantStatePayInMetaData, [merchantStatePayInMetaData]);
};

export const useAvailableStatePaymentMeta = () => {
    const availablePayment = useSelector(selectAvailableStatePaymentMeta);
    return useMemo(() => availablePayment, [availablePayment]);
}
